import { IBookmakerDictionaryApi } from '@/types';

export class BookmakerDictionaryItem {
    id: number;
    name: string;
    code: string;
    isVisibleForPlayer: 0 | 1;
    isActive: 0 | 1;
    inLiveFeed: 0 | 1;
    inPregameFeed: 0 | 1;

    constructor(data: IBookmakerDictionaryApi) {
        this.id = data.id;
        this.name = data.name_origin;
        this.code = data.code_origin;
        this.isVisibleForPlayer = data.is_visible_for_player;
        this.isActive = data.is_active;
        this.inLiveFeed = data.in_live_feed;
        this.inPregameFeed = data.in_pregame_feed;
    }
}
